import {
  voltZeroReview1,
  voltZeroReview2,
  voltZeroReview3,
  voltZeroReview4,
} from "@/assets/images/offer/volt-zero";
import type { OfferFaqItem } from "../../components/OfferFaq";
import type { LandingReview } from "../../components/LandingReviews";
import type { LandingStep } from "../../components/LandingSteps";

// Where each callout sits on the hero photo, as a share of its width and
// height, and how it leans.
export const HERO_CALLOUTS = [
  { label: "+12 puncte", left: 20.31, top: 37.31, rotation: 15 },
  { label: "+9 puncte", left: 42.29, top: 70.43, rotation: -9.38 },
  { label: "+7 puncte", left: 75.8, top: 71.48, rotation: -23.64 },
];

// The marketing score on the phone's gauge, and how much it last grew.
export const DEMO_SCORE = 677;
export const DEMO_SCORE_DELTA = 16;
export const MIN_SCORE = 300;
export const MAX_SCORE = 850;

export const RATE_TILES = [
  { score: "550", dae: "DAE 29%", tone: "orange" },
  { score: "650", dae: "DAE 14%", tone: "green" },
  { score: "720+", dae: "DAE 9%", tone: "blue" },
] as const;

export const REVIEWS: LandingReview[] = [
  {
    name: "Maria Ioana",
    date: "2026-07-11",
    avatar: voltZeroReview1,
    quote:
      "Aveam 589 cand am început, acum sunt la 621. Mai am de crescut dar macar vad ca merg in directia buna.",
    store: "google-play",
  },
  {
    name: "Vasile Dabuleanu",
    date: "2026-07-19",
    avatar: voltZeroReview2,
    quote:
      "-8 pct in prima luna, credeam ca fac ceva gresit. Volt AI mi-a spus ce sa schimb. In cateva luni am ajuns de la 520 la 561. E ok pentru cei ce vor sa-si reconstruiasca istoricul.",
    store: "app-store",
  },
  {
    name: "Alex Dumbrava",
    date: "2026-07-24",
    avatar: voltZeroReview3,
    quote:
      "Nu ma asteptam la minuni, am zis sa incerc. Folosesc putin din limita, pun banii inapoi la timp si dupa 7 luni +29 pct la fico.",
    store: "google-play",
  },
  {
    name: "Gabriel Badarau",
    date: "2026-08-09",
    avatar: voltZeroReview4,
    quote:
      "La inceput aveam limita 500 lei. Fara intarzieri mi-a crescut la 750 si dupa la 1000. Chiar ok.",
    store: "app-store",
  },
];

export const STEPS: LandingStep[] = [
  { title: "Activează Volt Zero", subtitle: "Durează 1 min" },
  { title: "Fă minim o plată lunară", subtitle: "Până la 30% din limită" },
  { title: "Ne ocupăm noi de restul", subtitle: "Înregistrăm plățile la B.C." },
];

export const FAQ: OfferFaqItem[] = [
  {
    question: "Ce este Volt Zero?",
    answer: [
      "Volt Zero este o linie de credit creată pentru construirea unui istoric de credit pozitiv. Plățile tale sunt raportate lunar la Biroul de Credit și pot contribui, în timp, la un profil de credit mai bun.",
      "Cu Volt Zero:",
    ],
    bullets: [
      "îți construiești istoricul de credit prin plăți la timp;",
      "adaugi o linie de credit în mixul tău de credite;",
    ],
  },
  {
    question: "Cum funcționează?",
    answer: [
      "Activezi Volt Zero, faci minim o plată lunară de până la 30% din limită, iar noi ne ocupăm de restul: înregistrăm plățile la Biroul de Credit în numele tău.",
    ],
  },
  {
    question: "Cât durează până văd primele rezultate?",
    answer: [
      "Primul raport ajunge la Biroul de Credit după prima ta plată. Majoritatea utilizatorilor văd o mișcare a scorului în 1-2 luni.",
    ],
  },
  {
    question: "Ce se întâmplă dacă ratez o plată?",
    answer: [
      "O plată ratată este raportată ca atare la Biroul de Credit și îți poate afecta negativ scorul — exact cum ar face-o orice altă linie de credit. Te anunțăm din timp ca să nu ajungi acolo.",
    ],
  },
  {
    question: "De cât timp e nevoie pentru a construi istoricul?",
    answer: [
      "Un istoric de credit solid se construiește în luni, nu în zile. Cu cât Volt Zero rămâne activ și plățile vin la timp, cu atât profilul tău de credit devine mai puternic.",
    ],
  },
];
